// extracted by mini-css-extract-plugin
export default {"page":"home_page__jOvW+"};